/* eslint-disable @nx/enforce-module-boundaries */
import { QuoteIcon } from '@mybridge/icons/Quote';
import { Avatar, Box, HStack, Link, Stack, Text } from '@mybridge/ui';
import moment from 'moment';
import { forwardRef } from 'react';
import {
  formatCommaSeparated,
  getUserFullName,
  getUserLocation,
  getUserPosition,
  getUserProfilePic,
} from 'v4/lib/commons';
export const MyTestimonialsUserCard = forwardRef(
  ({ user, message, createdAt, children, actions, ...props }, ref) => {
    return (
      <Stack>
        <Stack direction={['column', 'row']} alignItems={['flex-start', 'flex-start']}>
          <HStack alignItems="flex-start" flex={1} w="100%">
            <Avatar
              {...(user?.slug ? { as: Link, href: "/p/"+user?.slug } : {})}
              src={getUserProfilePic(user)}
              name={getUserFullName(user)}
            />
            <Stack spacing={0} flex={1}>
              <Text
                {...(user?.slug ? { as: Link, href: "/p/"+user?.slug } : {})}
                fontWeight="medium"
              >
                {getUserFullName(user)}
              </Text>
              {user?.position ? (
                <Text size="sm">
                  {formatCommaSeparated([getUserPosition(user), user?.industry])}
                </Text>
              ) : (
                ''
              )}
              <HStack mt={2} alignItems="flex-start">
                <QuoteIcon widht={'30'} height={'20'} />
                <Text width="fit-content" size="sm">{message}</Text>
              </HStack>
              {createdAt ? (
                <Text size="xs">
                  {moment(createdAt)?.format('ddd DD, MMM, YYYY')}
                </Text>
              ) : (
                ''
              )}
            </Stack>
          </HStack>
          <Box w={['100%', 'auto']} mt={[2, 0]} pl={['50px', 0]}>
            {actions}
          </Box>
        </Stack>
        {children}
      </Stack>
    );
  }
);
